module.exports = __webpack_public_path__ + "img/female_resultB.10fe4b4e.png";